import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { timer, throwError, retry } from 'rxjs';
import { SnackbarService } from '../services/error/snackbar.service';
import { isPlatformBrowser } from '@angular/common';

export const httpRetryInterceptor: HttpInterceptorFn = (req, next) => {
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
        return next(req);
    }

    const snackbarService = inject(SnackbarService);

    return next(req).pipe(
        retry({
            count: 3,
            delay: (error: HttpErrorResponse, retryCount: number) => {
                // Only retry on timeout errors (504) and server errors (5xx except 501)
                if (error.status === 504 || (error.status >= 500 && error.status <= 599 && error.status !== 501)) {
                    const delayTime = Math.min(1000 * Math.pow(2, retryCount - 1), 10000); // Exponential backoff, max 10s

                    // Show user-friendly message for 504 specifically
                    if (error.status === 504 && retryCount === 1) {
                        snackbarService.showResponse(
                            `Servern startar upp, försöker igen om ${delayTime / 1000} sekunder...`,
                            { duration: delayTime - 500 }
                        );
                    }

                    return timer(delayTime);
                }

                // Don't retry for other errors
                return throwError(() => error);
            }
        })
    );
};
